import { core } from '../core/index.js';
import { type AuthLogout } from './types.js';

/**
 * 同步接口, 注销用户信息
 * @returns
 */
export const logout: AuthLogout = () => {
  core.call<'fabric_auth.logout'>('fabric_auth.logout');
};
